(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('first-name', {
            parent: 'entity',
            url: '/first-name?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.firstName.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/first-name/first-names.html',
                    controller: 'FirstNameController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firstName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('first-name-detail', {
            parent: 'entity',
            url: '/first-name/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.firstName.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/first-name/first-name-detail.html',
                    controller: 'FirstNameDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('firstName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FirstName', function($stateParams, FirstName) {
                    return FirstName.get({id : $stateParams.id});
                }]
            }
        })
        .state('first-name.new', {
            parent: 'first-name',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-dialog.html',
                    controller: 'FirstNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('first-name');
                });
            }]
        })
        .state('first-name.edit', {
            parent: 'first-name',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-dialog.html',
                    controller: 'FirstNameDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FirstName', function(FirstName) {
                            return FirstName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('first-name.delete', {
            parent: 'first-name',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/first-name/first-name-delete-dialog.html',
                    controller: 'FirstNameDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FirstName', function(FirstName) {
                            return FirstName.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('first-name', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
